<template>
    <!-- Begin:PageContent-KeyDestinations -->
    <section id="content" v-show="getFlagSharedShowFlightSearchResults === false || getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel === true" :key="componentKey">
        <!-- Begin:Content - Best Price Caroussel -->
        <div class="container shortcode travel-ideas">
            <div class="block" style="margin-bottom: 20px !important;">
                <template v-if="modulo === 'booking'">
                    <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ headlinecontent[getCurrentLocale] }}</h1>
                </template>
                <template v-if="modulo === 'flightplan'">
                    <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ headlinecontent_flightplan[getCurrentLocale] }}</h1>
                </template>


                <!-- Begin:Best Price Destinations -->
                <div class="image-carousel style3 flex-slider" data-item-width="270" data-item-margin="30">
                    <ul class="slides image-box style9">
                        <!-- >>> Fuerteventura      (1)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'FUE' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('FUE')">
                                            <img src="/res/images/keydestinations/fue_fuerteventura_270x160.png" alt="Fuerteventura" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'FUE'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Fuerteventura (FUE)<small>{{ spain[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details" style="margin-bottom: 50px;">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('FUE') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('FUE')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('FUE') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('FUE') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('FUE') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('FUE') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=fuerteventura&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=fuerteventura&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=fuerteventura&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=fuerteventura&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Fuerteventura      (1)x -->

                        <!-- >>> Gran Canaria       (2)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'LPA' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('LPA')">
                                            <img src="/res/images/keydestinations/lpa_grancanaria_270x160.png" alt="Gran Canaria" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'LPA'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Gran Canaria (LPA)<small>{{ spain[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details" style="margin-bottom: 50px;">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('LPA') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('LPA')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('LPA') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('LPA') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('LPA') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('LPA') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=gran_canaria&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=gran_canaria&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=gran_canaria&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=gran_canaria&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Gran Canaria       (2)x -->

                        <!-- >>> Teneriffa          (3)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'TFS' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('TFS')">
                                            <img src="/res/images/keydestinations/tfs_teneriffa_270x160.png" alt="Teneriffa" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'TFS'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Teneriffa (TFS)<small>{{ spain[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details" style="margin-bottom: 50px;">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('TFS') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('TFS')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('TFS') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('TFS') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('TFS') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('TFS') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=teneriffa&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=teneriffa&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=teneriffa&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=teneriffa&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Teneriffa          (3)x -->

                        <!-- >>> Mallorca           (4)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'PMI' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('PMI')">
                                            <img src="/res/images/keydestinations/pmi_mallorca_270x160.png" alt="Mallorca" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'PMI'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Mallorca (PMI)<small>{{ spain[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('PMI') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('PMI')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('PMI') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('PMI') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('PMI') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('PMI') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=mallorca&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=mallorca&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=mallorca&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=mallorca&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Mallorca           (4)x -->





                        <!-- >>> Kos                (5)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'KGS' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('KGS')">
                                            <img src="/res/images/keydestinations/kos_kos_270x160.png" alt="Kos" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'KGS'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Kos (KGS)<small>{{ greece[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('KGS') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('KGS')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('KGS') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('KGS') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('KGS') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('KGS') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kos&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kos&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Kos                (5)x -->

                        <!-- >>> Korfu              (6)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'CFU' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('CFU')">
                                            <img src="/res/images/keydestinations/cfu_corfu_270x160.png" alt="Korfu" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'CFU'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Korfu (CFU)<small>{{ greece[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('CFU') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('CFU')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('CFU') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('CFU') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('CFU') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('CFU') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=korfu_paxi&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=Korfu&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=korfu_paxi&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=Korfu&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Korfu              (6)x -->

                        <!-- >>> Heraklion          (7)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'HER' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('HER')">
                                            <img src="/res/images/keydestinations/her_heraklion_270x160.png" alt="Heraklion" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'HER'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Heraklion (HER)<small>{{ greece[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('HER') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('HER')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('HER') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('HER') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('HER') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('HER') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kreta&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kreta&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kreta&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kreta&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Heraklion          (7)x -->

                        <!-- >>> Rhodos             (8)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'RHO' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('RHO')">
                                            <img src="/res/images/keydestinations/rho_rhodos_270x160.png" alt="Rhodos" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'RHO'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Rhodos (RHO)<small>{{ greece[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('RHO') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('RHO')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('RHO') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('RHO') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('RHO') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('RHO') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=rhodos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=rhodos&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=rhodos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=rhodos&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Rhodos             (8)x -->





                        <!-- >>> Burgas             (9) -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'BOJ' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('BOJ')">
                                            <img src="/res/images/keydestinations/boj_burgas_270x160.png" alt="Burgas" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'BOJ'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Burgas (BOJ)<small>{{ bulgary[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('BOJ') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('BOJ')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('BOJ') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('BOJ') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('BOJ') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('BOJ') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Burgas             (9) -->

                        <!-- >>> Antalya            (10)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'AYT' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('AYT')">
                                            <img src="/res/images/keydestinations/ayt_antalya_270x160.png" alt="Antalya" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'AYT'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Antalya (AYT)<small>{{ turkey[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('AYT') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('AYT')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('AYT') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('AYT') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('AYT') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('AYT') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=tuerkei&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=tuerkei&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=tuerkei&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=tuerkei&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Antalya            (10)x -->

                        <!-- >>> Hurghada           (11)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'HRG' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('HRG')">
                                            <img src="/res/images/keydestinations/hrg_hurghada_270x160.png" alt="Hurghada" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'HRG'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Hurghada (HRG)<small>{{ egypt[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('HRG') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('HRG')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('HRG') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('HRG') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('HRG') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('HRG') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=hurghada_safaga&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=hurghada_safaga&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=hurghada_safaga&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=hurghada_safaga&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Hurghada           (11)x -->

                        <!-- >>> Varna              (12)x -->
                        <li>
                            <div style="margin-top: 4px;">
                                <article class="box" v-bind:class="{ 'has-discount': getOffersSelectedDestination.destinationOfferAptCode === 'VAR' }">
                                    <!-- >>> Picture -->
                                    <figure>
                                        <a class="hover-effect" href="" @click.prevent="onClick_Destination('VAR')">
                                            <img src="/res/images/keydestinations/var_varna_270x160.png" alt="Varna" width="270" height="160" />
                                            <span class="discount" v-show="getOffersSelectedDestination.destinationOfferAptCode === 'VAR'"><span class="discount-text">{{ destinationwasclicked[getCurrentLocale] }}</span></span>
                                        </a>
                                    </figure>
                                    <!-- <<< Picture -->
                                    <!-- >>> Details -->
                                    <div class="details">
                                        <h3 class="box-title">Varna (VAR)<small>{{ bulgary[getCurrentLocale] }}</small></h3>
                                    </div>
                                    <div class="details">
                                        <span v-if="modulo === 'booking'">
                                            <span class="floatingicon"><i class="soap-icon-plane-right circle yellow-color takeoff-effect"></i></span>
                                            <!-- >>> Got a Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('VAR') !== 0">
                                                <small>{{ from[getCurrentLocale] }}</small>
                                                <a href="#" @click.prevent="onClick_Destination('VAR')" v-tooltip="clicktoseebestprices[getCurrentLocale]">{{ get_LowestPriceForKeyDes('VAR') | rndAmntRUAFWZ }}
                                            </a></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('VAR') !== 0">{{ flights[getCurrentLocale] }}<small>{{ offers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got a Price  -->

                                            <!-- <<< Got no Price  -->
                                            <span class="price" v-if="get_LowestPriceForKeyDes('VAR') === 0"><small>&nbsp;</small></span>
                                            <h4 class="box-title" v-if="get_LowestPriceForKeyDes('VAR') === 0">{{ flights[getCurrentLocale] }}<small>{{ nooffers[getCurrentLocale] }}</small></h4>
                                            <!-- <<< Got no Price  -->

                                            <hr>

                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>

                                        <span v-if="modulo === 'flightplan'">
                                            <span class="floatingicon"><i class="soap-icon-hotel circle yellow-color"></i></span>
                                            <span class="price"><small>{{ click[getCurrentLocale] }}</small><a href="https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser" target="_blank">{{ here[getCurrentLocale] }}</a></span>
                                            <h4 class="box-title">{{ packagetours[getCurrentLocale] }}<small>{{ offers2[getCurrentLocale] }}</small></h4>
                                        </span>
                                    </div>
                                    <!-- <<< Details -->
                                </article>
                            </div>
                        </li>
                        <!-- <<< Varna              (12)x -->
                    </ul>
                </div>
                <!-- End:Best Price Destinations -->


                <span class="text-small pull-left" v-if="getOffersSelectedDestination.price !== undefined"><a href="#" @click.prevent="onClick_Reset_KeyDestinations">{{ reset[getCurrentLocale] }}</a></span>
            </div>
        </div>
        <!-- End:Content - Best Price Caroussel -->



        <!-- Begin:Content - Detailed Bar Charts -->
        <div class="container block image-container animated fadeIn" data-animation-type="fadeIn" data-animation-duration="3" style="animation-duration: 3s; visibility: visible;" v-if="getOffersSelectedDestination.price !== undefined">
            <div class="row">
                <div id="main" class="col-md-12">
                    <div class="cruise-list">
                        <div class="listing-style3 cruise">
                            <article class="box">
                                <!-- Begin:Destinations Picture -->
                                <figure class="details col-sm-3" style="margin-top: 7px;">
                                    <a class=""><img width="270" height="160" alt="" :src="'/res/images/keydestinations/' + getOffersSelectedDestination.destinationOfferAptCode.toLowerCase() + '.png'"></a>
                                </figure>
                                <!-- End:Destinations Picture -->

                                <!-- Begin:Destinations Details -->
                                <div class="details col-sm-9" :key="fakeCounter">
                                    <div class="clearfix">
                                        <div class="row">
                                            <div class="col-xs-6 col-md-6">
                                                <div class="selector" style="text-align: end;">
                                                    <label class="smallSelectorDescs">&nbsp;</label>
                                                    <v-select style="margin-bottom: 20px;" name="depArprtCodeKeyDes" ref="depArprtCodeKeyDes" v-model="depArprtCodeKeyDes" :clearable="false" :options="getBookingDeparturesKeyDes" label="l" key="i" :value="i" class="style-chooser" v-bind:class="{ 'buttonglowing': getBookingOffersListFlightsMonthlyOffers.reduce(function(a, b){ return a + b; }, 0) === 0 }" :placeholder="this.departureairport[this.getCurrentLocale]" @input="onSelect_DepartureAirportKeyDes"></v-select>
                                                </div>
                                            </div>
                                            <div class="col-xs-2 col-md-2">
                                                <div class="selector" style="text-align: end;">
                                                    <label class="smallSelectorDescs">{{ adult[getCurrentLocale] }}:</label>
                                                    <v-select style="margin-bottom: 20px;" name="noADT" ref="noADT" v-model="noADT" :options="getListOfPaxes" :clearable="false" label="v" key="k" value="v" class="style-chooser" @input="onSelect_DepartureAirportKeyDes"></v-select>
                                                </div>
                                            </div>
                                            <div class="col-xs-2 col-md-2">
                                                <div class="selector" style="text-align: end;">
                                                    <label class="smallSelectorDescs">{{ child[getCurrentLocale] }}:</label>
                                                    <v-select style="margin-bottom: 20px;" name="noCHD" ref="noCHD" v-model="noCHD" :options="getListOfPaxes" :clearable="false" label="v" key="k" value="v" class="style-chooser" @input="onSelect_DepartureAirportKeyDes"></v-select>
                                                </div>
                                            </div>
                                            <div class="col-xs-2 col-md-2">
                                                <div class="selector" style="text-align: end;">
                                                    <label class="smallSelectorDescs">{{ infant[getCurrentLocale] }}:</label>
                                                    <v-select style="margin-bottom: 20px;" name="noINF" ref="noINF" v-model="noINF" :options="getListOfPaxes" :clearable="false" label="v" key="k" value="v" class="style-chooser" @input="onSelect_DepartureAirportKeyDes"></v-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="clearfix">
                                        <!-- <v-select style="margin-bottom: 20px;" name="depArprtCodeKeyDes" ref="depArprtCodeKeyDes" :clearable="false" v-model="depArprtCodeKeyDes" :options="getBookingDeparturesKeyDes" label="l" key="i" :value="i" class="style-chooser" v-bind:class="{ 'buttonglowing': getBookingOffersListFlightsMonthlyOffers.reduce(function(a, b){ return a + b; }, 0) === 0 }" :placeholder="this.departureairport[this.getCurrentLocale]" @input="onSelect_DepartureAirportKeyDes"></v-select> -->
                                        <h4 class="box-title pull-left">{{ getOffersSelectedDestination.desCityName }}<small>{{ nextmonths[getCurrentLocale] }}</small></h4>
                                        <span class="price pull-right"><small style="text-align: end;">{{ from2[getCurrentLocale] }}</small>{{ getOffersSelectedDestination.price | rndAmntRUAFWZ }}</span>
                                    </div>

                                    <div class="character clearfix">
                                        <div class="col-xs-1 cruise-logo">
                                            <img src="/res/images/logo-centered2.png" alt="" style="height: 30px;" />
                                        </div>
                                        <div class="col-xs-6 date">
                                            <i class="soap-icon-clock yellow-color"></i>
                                            <div>
                                                <span class="skin-color">{{ mydate[getCurrentLocale] }}</span><br>{{ next6months[getCurrentLocale] }}
                                            </div>
                                        </div>
                                        <div class="col-xs-6 departure">
                                            <i class="soap-icon-departure yellow-color"></i>
                                            <div>
                                                <span class="skin-color">{{ fromDes[getCurrentLocale] }}</span><br>{{ choosenStartAirport }}
                                            </div>
                                        </div>
                                        <div class="col-xs-6 departure">
                                            <i class="soap-icon-departure yellow-color"></i>
                                            <div>
                                                <span class="skin-color">{{ destination[getCurrentLocale] }}</span><br>{{ getOffersSelectedDestination.desCityName }}, {{ getOffersSelectedDestination.destinationOfferAptCode }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="clearfix">
                                    </div>
                                </div>
                                <!-- End:Destinations Details -->
                            </article>
                        </div>

                        <!-- Begin:Destinations Bar Charts Details -->
                        <div v-if="getBookingOffersListFlightsMonthlyOffers.reduce(function(a, b){ return a + b; }, 0) > 0" style="background: #fff; padding: 20px;" :key="fakeCounter">
                            <sdr-shared-keydestinations-bar-charts :chartdata="this.get_barchartsChartdata()" :options="barchartsOptions"></sdr-shared-keydestinations-bar-charts>

                            <a class="button btn-large uppercase full-width silver" style="margin-top:40px;" v-if="getBookingOffersChoosenFlightByUser === null">{{ findflights[getCurrentLocale] }}</a>
                            <button class="btn-large icon-check uppercase full-width" style="margin-top:40px;" v-if="getBookingOffersChoosenFlightByUser !== null" @click.prevent="onClick_Submit_FindFlightsViaOffers()" type="submit">{{ getButtonName() }}</button>
                        </div>
                        <!-- End:Destinations Bar Charts Details -->
                    </div>
                </div>
            </div>
        </div>
        <!-- End:Content - Detailed Bar Charts -->
    </section>
    <!-- End:PageContent-KeyDestinations -->
</template>


<script>
    import KeyDestinationsBarCharts from '../../shared/charts/KeyDestinationsBarChart.vue'

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import moment from 'moment';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-keydestinations-bar-charts': KeyDestinationsBarCharts,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                noADT: { "k": 1, "v": "1" },
                noCHD: { "k": 0, "v": "0" },
                noINF: { "k": 0, "v": "0" },
                // >>> --------------------------

                adult: {
                    en: 'Adult (from 12+)',
                    de: 'Erw. (ab 12+)',
                },
                child: {
                    en: 'Child (2-12)',
                    de: 'Kind (2-12)',
                },
                infant: {
                    en: 'Infant (up to 2)',
                    de: 'Baby (bis 2)',
                },
                // >>> --------------------------
                rememberClickedMonth: null,
                // >>> --------------------------
                headlinecontent: {
                    en: 'Our most beautiful destinations - Search for best prices',
                    de: 'Unsere schönsten Reiseziele - Suche nach besten Preisen',
                },
                headlinecontent_flightplan: {
                    en: 'Discover our best destinations - Directly on the map',
                    de: 'Entdecken Sie unsere besten Reiseziele - Direkt auf der Karte',
                },
                // >>> --------------------------
               fromDes: {
                    en: 'from (Airport)',
                    de: 'von (Flughafen)',
                },
                destination: {
                    en: 'to (Country)',
                    de: 'nach (Land)',
                },
                mydate: {
                    en: 'Time period',
                    de: 'Zeitraum',
                },
                next6months: {
                    en: 'Next 6 Months',
                    de: 'Nächsten 6 Monate',
                },
                from: {
                    en: 'already from',
                    de: 'schon ab',
                },
               click: {
                    en: 'click',
                    de: 'klick',
                },
                from2: {
                    en: 'Best Price',
                    de: 'Bester Preis',
                },
                flights: {
                    en: 'Flights',
                    de: 'Flüge',
                },
                packagetours: {
                    en: 'Holidays',
                    de: 'Pauschalsuche',
                },
                offers: {
                    en: 'Destination',
                    de: 'Reiseziel',
                },
                offers2: {
                    en: 'schauinsland-reisen',
                    de: 'schauinsland-reisen',
                },
                nooffers: {
                    en: 'No Offer',
                    de: 'Kein Angebot',
                },
                here: {
                    en: 'Here',
                    de: 'Hier',
                },
                reset: {
                    en: 'Reset Pricesearch',
                    de: 'Reset Preissuche',
                },
                clicktoseebestprices: {
                    en: 'Click here for best prices!',
                    de: 'Klicke hier für Beste Preise!',
                },
                // >>> --------------------------
                spain: {
                    en: 'Spain',
                    de: 'Spanien',
                },
                greece: {
                    en: 'Greece',
                    de: 'Griechenland',
                },
                bulgary: {
                    en: 'Bulgary',
                    de: 'Bulgarien',
                },
                turkey: {
                    en: 'Turkey',
                    de: 'Türkei',
                },
                hungary: {
                    en: 'Hungary',
                    de: 'Ungarn',
                },
                egypt: {
                    en: 'Egypt',
                    de: 'Ägypten',
                },
                nextmonths: {
                    en: 'Your Destination',
                    de: 'Ihr Reiseziel',
                },
                // >>> --------------------------
                destinationwasclicked: {
                    en: 'Selected!',
                    de: 'Gewählt!',
                },
                departureairport: {
                    en: 'Please choose your departure airport',
                    de: 'Wählen Sie Ihren Startflughafen',
                },
                // >>> --------------------------
                findflights: {
                    en: 'FIND BEST PRICE AND FLIGHTS IN MONTH',
                    de: 'FINDE BESTEN PREIS UND FLÜGE IM MONAT',
                },
                // >>> --------------------------
                bestprice: {
                    en: 'Best Price of the Month: ',
                    de: 'Bester Preis des Monat: ',
                },
                // >>> --------------------------
                bestprices6months: {
                    en: 'Our best Prices in the next 6 Month (Click)',
                    de: 'Unsere besten Preise der nächsten 6 Monate (Klick)',
                },
                // >>> --------------------------
                tomanypeople: {
                    en: 'Please use our group booking form for flight bookings of 11 or more passengers or contact customer service.',
                    de: 'Bitte nutzen Sie bei einer Flugbuchung ab 11 Passagiere unser Gruppenbuchungsformular oder wenden Sie sich an den Kundenservice.',
                },
                // >>> --------------------------
                airportsOriginsKeyDes: [],
                airportsDestinationsKeyDes: [],
                departuresKeyDesLoaded: false,
                destinationsKeyDesLoaded: false, // Des Aiports loaded?
                depArprtCodeKeyDes: '',  // model, new select Field
                // >>> --------------------------
                choosenStartAirport: '',
                // >>> --------------------------
                fakeCounter: 0,
                // >>> -------------------------- Props for BarChart Component
                prevChartData: [],
                barchartsOptions:  {
                    responsive: true,
                    maintainAspectRatio: false,
                    onClick: this.onClick_BarChart,
                    tooltips: {
                        displayColors: false,
                        titleFontSize: 15,
                        bodyFontSize: 14,
                        backgroundColor: '#ab3b7a',
                        callbacks: {
                            label: function(tooltipItem, data) {
                                var me = this,
                                    k,
                                    p;


                                k = (Math.round(tooltipItem.yLabel * 100) / 100).toString();
                                k += (k.indexOf('.') == -1) ? '.00' : '00';
                                p = k.indexOf('.');

                                return 'Best Price of Month: ' + k.substring(0, p) + '.' + k.substring(p + 1, p + 3) + '€';
                            }
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                fontSize: 14,
                                fontColor:'#ab3b7a',
                                callback: function(value, index, values) {
                                    return value + '€';
                                }
                            },
                        }],
                        xAxes: [{
                            ticks: {
                                fontSize: 14,
                                fontColor:'#ab3b7a',
                            },
                            gridLines: {
                                display: false,
                            }
                        }]
                    },
                    legend: {
                        labels: {
                            fontSize: 16,
                            fontColor:'#ab3b7a',
                        },
                        onClick: function (e) {
                            e.stopPropagation();
                        }
                    },
                },
                // >>> --------------------------
                componentKey: 0,
                // >>> --------------------------
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedShowFlightSearchResults',
                'getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel',
                'getOffers',
                'getOffersSelectedDestination',
                'getBookingDeparturesKeyDes', // call: results
                'getListOfPaxes',
                'getBookingOffersListFlightsMonthlyOffers', // call: results
                'getBookingOffersFlightIdViaMonth', // get: Offers FlightId via clicked Months
                'getBookingOffersChoosenFlightByUser', // get: Get chosen Floight by User
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            var me = this;


            me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> created');
            if (this.modulo === 'booking') {
                me.actn_call_Offers();
            }

        }, // eo function created()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_Offers', // call:
                'actn_call_DeparturesKeyDes', // call:
                'actn_call_ListFlightsMonthlyOffers', // call:
                'actn_call_ListFlightsAfterUserSelectedBestPrice', // call:
                'actn_setBookingOffersSelectedDestination', // set: user selected destination
                'actn_setBookingOffersListFlightsMonthlyOffers',
                'actn_setBookingOffersChoosenFlightByUser',

                'actn_FlagSharedShowFlightSearchResults',
                'actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel',
                'actn_FlagServicesShowBookingnoSearchResults',
                'actn_setBookingAirports',
                'actn_setBookingUsersSearchData',
                'actn_set_areWeInServicesBookingNoMode',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_Destination()
            *
            * Desc: KeyDestination was selected/clicked.
            * Note: 'Get Dep Airports' for clicked KeyDes Call here.
            * Note: Reset Dep Aiprt here.
            *
            * @param {String} des (e.g.: 'FUE')
            */
            onClick_Destination: function(des) {

                var me = this,
                    destinationObject = {};


                me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> onClick_Destination');
                this.depArprtCodeKeyDes = ''; // reset model
                this.actn_setBookingOffersListFlightsMonthlyOffers([]); // reset
                this.actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel(true);
                this.actn_FlagSharedShowFlightSearchResults(false);             // Hide 'Section'
                this.choosenStartAirport = '';
                this.noADT = { "k": 1, "v": "1" };
                this.noCHD = { "k": 0, "v": "0" };
                this.noINF = { "k": 0, "v": "0" };

                 if (this.modulo !== 'flightplan') {
                    destinationObject = me.getOffers.find(offer => offer.destinationOfferAptCode === des);
                    if (destinationObject !== undefined) {
                        destinationObject = destinationObject;

                        this.actn_setBookingOffersSelectedDestination(destinationObject);
                        this.actn_call_DeparturesKeyDes(destinationObject);
                    }
                 }

            }, // eo function onClick_Destination()


            /*******************************************************************
            * onSelect_DepartureAirportKeyDes()
            *
            * Desc: KeyDestinations Departure Airport was selected.
            * Note: 'Get 6 Months Offer' KeyDes Combination Call here.
            *
            */
            onSelect_DepartureAirportKeyDes: function() {

                var me = this,
                    requestParamObject = {};


                me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> onSelect_DepartureAirportKeyDes');
                if (this.depArprtCodeKeyDes !== '') {
                    // >>> 1. Reset --------------------------------------------
                    this.actn_setBookingOffersChoosenFlightByUser(null); // reset

                    // >>> 1a. To many Pax -------------------------------------
                    if (+this.noADT.k + +this.noCHD.k + +this.noINF.k > 10) {
                        me.$toasted.global.sdr_app_error({
                            message : this.tomanypeople[this.getCurrentLocale]
                        });
                        return;
                    }

                    // >>> 2. Builds Object ------------------------------------
                    requestParamObject = {
                        depArprtCode: this.depArprtCodeKeyDes.i, // submitEvent.target.elements.depArprtCode.value,
                        desArprtCode: this.getOffersSelectedDestination.destinationOfferAptCode, // submitEvent.target.elements.desArprtCode.value,
                        noADT: this.noADT.k,
                        noCHD: this.noCHD.k,
                        noINF: this.noINF.k,
                        ojArprtCode: '', // not clear
                        ojType: '', // not clear
                        depAfter: moment().format('YYYY-MM-DDTHH:mm:ss+0000'),
                        // depBefore: moment().add(5, 'months').format('YYYY-MM-DDTHH:mm:ss+0000'),
                        retAfter: moment().add(5, 'months').format('YYYY-MM-DDTHH:mm:ss+0000'),
                        rTrip: true,
                        limit: 6,
                        monhtlyOffer: true,
                    };
                    this.choosenStartAirport = this.depArprtCodeKeyDes.l;


                    this.actn_call_ListFlightsMonthlyOffers(requestParamObject);
                }

            }, // eo function onSelect_DepartureAirportKeyDes


            /*******************************************************************
            * onClick_Reset_KeyDestinations()
            *
            * Desc: Reset KeyDestinations Stuff.
            * Note:
            *
            */
            onClick_Reset_KeyDestinations: function() {

                var me = this,
                    requestParamObject = {};


                me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> onClick_Reset_KeyDestinations');
                this.depArprtCodeKeyDes = ''; // reset model
                this.actn_setBookingOffersSelectedDestination({});
                this.actn_setBookingOffersChoosenFlightByUser(null);
                this.actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel(false);
                this.actn_FlagSharedShowFlightSearchResults(false);             // Hide 'Section'

            }, // eo function onClick_Reset_KeyDestinations()


            /*******************************************************************
            * onClick_BarChart()
            *
            * Desc: Find Right Flight (via clicked Month).
            * Note:
            *
            * @param {Object} ev
            * @param {Object} data
            */
            onClick_BarChart: function(ev, data) {

                var me = this,
                    clickedMonth = null;


                me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> onClick_BarChart');
                if (data[0] !== undefined) {
                    if (data[0]._model !== undefined) {
                        this.actn_FlagSharedShowFlightSearchResults(false);     // Hide 'Section'
                        clickedMonth = data[0]._model.label;                    // catch label
                        this.rememberClickedMonth = clickedMonth;               // save locally
                        this.getBookingOffersFlightIdViaMonth(clickedMonth);    // find flight
                    }
                }

            }, // eo function onClick_Reset_KeyDestinations()


            /*******************************************************************
            * onClick_Submit_FindFlightsViaOffers()
            *
            * Desc:
            * Note:
            *
            */
            onClick_Submit_FindFlightsViaOffers: function() {

                var me = this,
                    requestParamObject = {};


                me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> onClick_Submit_FindFlightsViaOffers');
                // >>> 1. Builds Object ----------------------------------------
                requestParamObject = {
                    depArprtCode: this.getBookingOffersChoosenFlightByUser.depArprt.i,
                    desArprtCode: this.getBookingOffersChoosenFlightByUser.desArprt.i,
                    noADT: this.noADT.k,
                    noCHD: this.noCHD.k,
                    noINF: this.noINF.k,
                    ojArprtCode: '',
                    ojType: '',
                    depAfter: moment(this.getBookingOffersChoosenFlightByUser.depDT).subtract(0, 'days').format('YYYY-MM-DDT00:00:00+0000'),
                    retAfter: moment(this.getBookingOffersChoosenFlightByUser.depDT).add(3, 'days').format('YYYY-MM-DDT23:59:59+0000'),
                    rTrip: true,
                    limit: 6,
                };

                // >>> 2. State Stuff ------------------------------------------
                this.actn_FlagSharedShowFlightSearchResults(false);             // Hide 'Section'
                this.actn_FlagServicesShowBookingnoSearchResults(false);        // Hide 'Section'
                this.actn_setBookingAirports({                                  // remember in state
                    depArprtCode: requestParamObject.depArprtCode,
                    depArprtName: this.getBookingOffersChoosenFlightByUser.depArprt.l,
                    desArprtCode: requestParamObject.desArprtCode,
                    desArprtName: this.getBookingOffersChoosenFlightByUser.desArprt.l
                });
                this.actn_setBookingUsersSearchData(requestParamObject);        // remember in state
                this.actn_set_areWeInServicesBookingNoMode(false);              // we are NOT in bookingno mode

                // >>> 3. Call -------------------------------------------------
                this.actn_call_ListFlightsAfterUserSelectedBestPrice(requestParamObject);

            }, // eo function onClick_Submit_FindFlightsViaOffers()



            /******************************************************************* 'Offers Utilities'
            * Offers Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_LowestPriceForKeyDes()
            *
            * Desc: Return Price of given DKeyestination.
            * Note:
            *
            * @param {String} des (e.g.: 'FUE')
            */
            get_LowestPriceForKeyDes: function (des) {

                let me = this,
                    lowest = 0;


                // me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> get_LowestPriceForKeyDes');
                if (me.getOffers.length > 0) {
                    lowest = me.getOffers.find(offer => offer.destinationOfferAptCode === des);
                    if (lowest !== undefined) {
                        lowest = lowest.price;
                    } else {
                        lowest = 0;
                    }
                }


                return lowest;

            }, // eo function get_LowestPriceForKeyDes()


            /*******************************************************************
            * get_barchartsChartdata()
            *
            * Desc: Build up Charts Objects.
            * Note:
            *
            */
            get_barchartsChartdata: function () {

                let me = this,
                    depAfterMonthIndex = moment().month(), // find right index
                    retAfterMonthIndex = moment().add(5, 'months').month(),
                    months_en = ['January','February','March','April','May','June','July','August','September','October','November','December','January','February','March','April','May','June'],
                    months_de = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember','Januar','Februar','März','April','Mai','Juni'],
                    labels = [], // labels to send
                    data = this.getBookingOffersListFlightsMonthlyOffers, // price data to send
                    barchartsChartdata = {
                        labels      : '', // gets filled up later
                        datasets    : [
                            {
                                label               : this.bestprices6months[me.getCurrentLocale],
                                borderColor         : "#fff",
                                borderWidth         : "2",
                                hoverBorderColor    : "#666",
                                backgroundColor: [
                                    "rgba(2, 62, 138, 0.7)",
                                    "rgba(0, 119, 182, 0.7)",
                                    "rgba(0, 150, 199, 0.7)",
                                    "rgba(0, 180, 216, 0.7)",
                                    "rgba(72, 202, 228, 0.7)",
                                    "rgba(144, 224, 239, 0.7)",
                                ],
                                hoverBackgroundColor: [
                                    "#023e8a",
                                    "#0077b6",
                                    "#0096c7",
                                    "#00b4d8",
                                    "#48cae4",
                                    "#90e0ef",
                                ],

                                // barPercentage: 0.5,
                                // barThickness: 6,
                                // maxBarThickness: 8,
                                // minBarLength    : 2,
                                data            : ''
                            }
                        ]
                    };


                me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> get_barchartsChartdata');
                // >>> ---------------------------------------------------------// right labels
                if (me.getCurrentLocale === 'de') {
                    labels = months_de.slice(depAfterMonthIndex, depAfterMonthIndex + 6);
                } else {
                    labels = months_en.slice(depAfterMonthIndex, depAfterMonthIndex + 6);
                }
                barchartsChartdata.labels = labels;                             // add labels

                barchartsChartdata.datasets[0].data = data;                     // add prices
                // <<< ---------------------------------------------------------


                // >>> --------------------------------------------------------- Rerender Component (using FakeCounter)
                if (JSON.stringify(this.prevChartData) !== JSON.stringify(data)) {
                    this.fakeCounter = this.fakeCounter + 1;
                }
                this.prevChartData = data; // remember it
                // <<< ---------------------------------------------------------


                return barchartsChartdata;

            }, // eo function get_barchartsChartdata()


            /*******************************************************************
            * getListOfPaxes()
            *
            * Desc:
            * Note:
            *
            */
            getListOfPaxes: function() {

                return this.listOfPaxes;

            }, // eo function getListOfPaxes()


            /*******************************************************************
            * getButtonName()
            *
            * Desc:
            * Note:
            *
            */
            getButtonName: function () {

                return this.findflights[this.getCurrentLocale] + ': ' + this.rememberClickedMonth;

            }, // eo function getButtonName()

        }, // eo  methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .image-box .discount {
        text-indent: 4px;
    }
</style>
<style>
    .hover-effect:after {
        xbackground-color: #ab3b7a;
    }


    .five-stars-container {
        font-size: 13px;
        line-height: 1.4em;
    }


    /* Karroussell */
    .image-box.style9 .details {
        text-align: left;
    }


    /* */
    .floatingicon {
        float: left;
        text-align: start;
        margin-right: 7px;
        margin-top: 5px;
        width: 2.2em;
        height: 2.2em;
    }



    /* .image-box .discount {
        text-indent: 4px;
    } */


    .image-carousel.style3 {
         margin-bottom: 0px;
    }


    .smallSelectorDescs {
        font-size: 12px !important;
        text-transform: none !important;
        font-weight: 500 !important;
        margin-bottom: 7px !important;
    }

    /* >>> -------------------------------------------------------------------*/
    .buttonglowing {
        background-color: #004a7f;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        border: none;
        color: #ffffff;
        cursor: pointer;
        /* display: inline-block; */
        /* font-family: Arial;
        font-size: 20px; */
        /* padding: 5px 10px;
        text-align: center;
        text-decoration: none; */
        -webkit-animation: glowing 1500ms infinite;
        -moz-animation: glowing 1500ms infinite;
        -o-animation: glowing 1500ms infinite;
        animation: glowing 1500ms infinite;
    }


    @-webkit-keyframes glowing {
        0% {
            background-color: #e11a33; /* b20000 */
            -webkit-box-shadow: 0 0 10px #e11a33; /* b20000 */
        }
        50% {
            background-color: #7c2525; /* ff0000 */
            -webkit-box-shadow: 0 0 20px #7c2525; /* ff0000 */
        }
        100% {
            background-color: #e11a33;
            -webkit-box-shadow: 0 0 10px #e11a33;
        }
    }

    @-moz-keyframes glowing {
        0% {
            background-color: #e11a33;
            -moz-box-shadow: 0 0 10px #e11a33;
        }
        50% {
            background-color: #7c2525;
            -moz-box-shadow: 0 0 20px #7c2525;
        }
        100% {
            background-color: #e11a33;
            -moz-box-shadow: 0 0 10px #e11a33;
        }
    }

    @-o-keyframes glowing {
        0% {
            background-color: #e11a33;
            box-shadow: 0 0 10px #e11a33;
        }
        50% {
            background-color: #7c2525;
            box-shadow: 0 0 20px #7c2525;
        }
        100% {
            background-color: #e11a33;
            box-shadow: 0 0 10px #e11a33;
        }
    }

    @keyframes glowing {
        0% {
            background-color: #e11a33;
            box-shadow: 0 0 10px #e11a33;
        }
        50% {
            background-color: #7c2525;
            box-shadow: 0 0 0px #7c2525;
        }
        100% {
            background-color: #e11a33;
            box-shadow: 0 0 10px #e11a33;
        }
    }


    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.5em;
        }
    }
</style>